import { render, staticRenderFns } from "./Debates.vue?vue&type=template&id=5fffe7b5&"
import script from "./Debates.vue?vue&type=script&lang=js&"
export * from "./Debates.vue?vue&type=script&lang=js&"
import style0 from "./Debates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Debates.vue"
export default component.exports